import React, { useState } from "react";
import { toast } from "sonner";
import { Download, KeyRound, Loader2 } from "lucide-react";
import { api, downloadBlob, errMsg } from "../../../lib/api";

const fmtSize = (kb) => (kb >= 1024 ? `${(kb / 1024).toFixed(1)} MB` : `${kb} KB`);

export const KitList = ({ kit = [] }) => {
  const [busy, setBusy] = useState(null);
  const get = async (f) => {
    setBusy(f.key);
    try { downloadBlob(await api.adminMobileKit(f.key), f.name); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  return (
    <div className="rounded-2xl border border-slate-200 bg-white" data-testid="mobile-kit-list">
      <div className="p-5 sm:p-6 border-b border-slate-100">
        <h2 className="font-display text-lg font-semibold text-slate-900">Store upload kit</h2>
        <p className="mt-1 text-sm text-slate-500">Everything needed to list Ishukart on Google Play and the App Store. Only admins can download these.</p>
      </div>
      <ul className="divide-y divide-slate-100">
        {kit.map((f) => (
          <li key={f.key} className="flex items-center gap-4 px-5 sm:px-6 py-3.5" data-testid={`mobile-kit-${f.key}`}>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium text-slate-800 flex items-center gap-1.5">{f.key === "android_signing" && <KeyRound size={14} className="text-amber-600" />}{f.label}</p>
              <p className="text-xs font-mono text-slate-400 truncate">{f.name} · {f.ready ? fmtSize(f.size_kb) : "not ready"}</p>
            </div>
            <button disabled={!f.ready || busy === f.key} onClick={() => get(f)} data-testid={`mobile-kit-${f.key}-download`}
              className="shrink-0 h-8 px-3 inline-flex items-center gap-1.5 rounded-lg border border-slate-300 text-xs font-medium text-slate-700 hover:bg-slate-100 disabled:opacity-50">
              {busy === f.key ? <Loader2 size={13} className="animate-spin" /> : <Download size={13} />} Download
            </button>
          </li>
        ))}
      </ul>
      <p className="px-5 sm:px-6 py-3 text-xs text-amber-700 bg-amber-50 rounded-b-2xl" data-testid="mobile-kit-key-warning">
        Back up the Android signing key somewhere safe — every future update of the app must be signed with the same key.
      </p>
    </div>
  );
};

export default KitList;
